<div *ngIf="side_view ; else spinner" class="{{
    logStatus_set == 'PENDING' || logStatus_set == 'APPROVED'
      ? 'logs-box-view w-100'
      : 'log-default w-100 tooltip-timeline'
  }}">
  <div class="row my-2 d-flex align-items-center">
    <div class="col-md-12 col-12">
      <div class="d-flex my-2">
        <div class="column pos-rel w-100">
          <h4 class="card-title mx-2" style="font-weight: 500; color: white">
            <i class="fa-solid pi-fw fa-chalkboard v4-ml-2"></i>{{ side_view?.title }}
          </h4>
        </div>
      </div>
    </div>
  </div>

  <!-- For View -->
  <div class="col-12">
    <span class="color-bold"><i class="pi pi-pencil mx-2"></i>{{ "Description" | translator
      }}: </span>
    <span [innerHTML]="side_view?.description"></span>
  </div>


  <div class="overflow-ui">
    <!-- start date -->
    <div class="program-flexx">
      <div class="cust-flex">
        <span class="btn-flex mx-1 my-2">
          <span class="d-flex flex-column">
            <span class="btn-css mx-2">{{"Start Date" | translator}}</span>
            <span class="btn-css mx-2 font-0_8rem font-weight-200">
              {{ side_view?.start_date?.substring(0,10) }}
            </span>
          </span>
          <span class="icon-box cccc">
            <i class="pi pi-calendar-plus font-500"></i>
          </span>
        </span>
      </div>
      <div class="cust-flex">
        <span class="btn-flex mx-1 my-2">
          <span class="d-flex flex-column">
            <span class="btn-css mx-2">{{ "End Date" | translator }}</span>
            <span class="btn-css mx-2 font-0_8rem font-weight-200">
              {{ side_view?.end_date?.substring(0,10) }}
            </span>
          </span>
          <span class="icon-box cccc">
            <i class="pi pi-calendar-minus font-500"></i>
          </span>
        </span>
      </div>
    </div>
    <!-- end date -->

    <!-- breadcrumb -->
    <!-- <div class="d-flex flex-row align-items-center wrapp">
    <span
      class="d-flex align-items-center my-1"
      *ngFor="let item of side_view?.breadcrumbs; let i = index"
      [routerLink]="item?.routerLink"
    >
      <span class="custom-bredcrum-btn d-flex align-items-center">
        <i
          [hidden]="item?.image_sq"
          class="{{ item?.icon }} me-1"
        ></i>
        <img
          [hidden]="!item?.image_sq"
          [src]="staticURL + item?.image_sq"
          style="max-height: 1.2rem; max-width: 1.2rem"
          class="blacknWhite img-fluid me-1"
        />
        {{ item?.label }}
      </span>
      <span class=""
        ><i class="pi pi-fw pi-angle-left v4-bredcrum-icn"></i
      ></span>
    </span>
  </div> -->
    <!-- breadcrumb end -->

    <h4> <i class="pi pi-sitemap p-2" style="font-size: 1.2rem"></i>{{'Assigned Ous' | translator}}</h4>

    <div class="d-flex flex-wrap">
      <div *ngFor="let ou of side_view.ous" class="ouBread">
        <div *ngIf="checkisImg(ou.image); else elseBlock" class="heading-imgg">
          <img src="{{ staticURL }}{{ ou.image }}" class="img-fluid p-1 tree-img-v4" />
        </div>
        <ng-template #elseBlock>
          <i class="{{ ou.image }} p-2" style="font-size: 1rem"></i>
        </ng-template>
        <span class="v4-color-white"> {{ou.name}} </span>
      </div>
    </div>


    <h4> <i class="fa-solid pi-fw fa-chalkboard v4-ml-2" style="font-size: 1.2rem"></i>{{'Trainings' | translator}}</h4>

    <hr />

    <p-accordion class="w-full v4-acordian-custom">
      <ng-container *ngFor="let course of side_view?.courses let i = index">
        <p-accordionTab *ngIf="isUserAttendee(course)" class="my-3 v4-acordian-custom" iconPos="end">
          <ng-template class="v4-acordian-custom" pTemplate="header">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex align-items-center">
                <!-- <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i> -->
                <div class="v4-icon-bg mx-2">
                  <img class="{{course.trainingId?.image ? 'toggle-img-2':'toggle-img'}}"
                    src="{{course?.trainingId?.image ? staticURL+course.trainingId?.image: '../../../assets/e-book.png'}}"
                    alt="loading..." />
                </div>
                <span class="vertical-align-middle font-1_1rem">{{ course?.trainingId?.title}}</span>
              </div>
              <div class="mob-mr d-flex">
                <span class="tabel-circle-btn m-1" *ngIf="from!='user-profile'">
                  <i pTooltip='{{"Edit"| translator}}' tooltipPosition="top" class="pi pi-file-edit"
                    (click)="openCourse(course?.trainingId?._id,'Edit')"></i>
                </span>
                <span class="tabel-circle-btn-green m-1"
                  *ngIf="course.completedAttendees.includes(userId) && from == 'user-profile'; else view ">
                  <i pTooltip='{{"Already Completed"| translator}}' tooltipPosition="top" class="pi pi-check"></i>
                </span>
                <ng-template #view>
                  <span class="tabel-circle-btn m-1" *ngIf="isUserAttendee(course) || from != 'user-profile' ">
                    <i pTooltip='{{"View"| translator}}' (click)="openCourse(course?.trainingId?._id,'View')"
                      tooltipPosition="top" class="pi pi-eye"></i>
                  </span>
                  <span class="tabel-circle-btn-yellow m-1" *ngIf="!isUserAttendee(course) && from == 'user-profile' ">
                    <i pTooltip='{{"You are registered in another session of this training"| translator}}'
                      tooltipPosition="top" class="pi pi-info"></i>
                  </span>
                </ng-template>
                <!-- <span class="mx-2">({{ log.createdAt | date }})</span> -->
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div class="container">
              <!-- For View -->
              <div class="col-12">
                <span class="color-bold"><i class="pi pi-pencil mx-2"></i>{{ "Description" | translator
                  }}: </span>
                <span [innerHTML]="course?.trainingId?.description"></span>
              </div>

              <!-- Sessions list dot ui end  -->
              <app-training-timeline [sessions]="course?.trainingId?.sessions"></app-training-timeline>
              <!--  Sessions list  dot ui end  -->
              <hr>

              <ng-container *ngIf="from!='user-profile'">
                <h4> <i class="pi pi-users v4-ml-2" style="font-size: 1.5rem"></i>{{'Users added in training' |
                  translator}}</h4>


                <p-table [value]="course?.trainingId?.attendees" [paginator]="true" [showCurrentPageReport]="true"
                  [rows]="5">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th>{{'user name' | translator}}</th>
                      <th>{{'Email' | translator}}</th>
                      <th>{{'Phone Number'}}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-user let-columns="columns">
                    <tr>
                      <td>{{user?.name?.first}} {{user?.name?.middle}} {{user?.name?.last}}</td>
                      <td>{{user?.email}}</td>
                      <td>{{user?.phone}}</td>
                      <!-- <td>rao</td>
                    <td>usamailcom</td>
                    <td>08088237483</td> -->
                    </tr>
                  </ng-template>
                </p-table>
              </ng-container>

            </div>
          </ng-template>
        </p-accordionTab>
      </ng-container>
    </p-accordion>

    <ng-container *ngIf="from !='user-profile'">
      <h4 class="mt-2"> <i class="pi pi-users v4-ml-2" style="font-size: 1.5rem"></i>{{'Users added in training program'
        | translator}}</h4>
      <p-table [value]="side_view.attendees" [paginator]="true" [showCurrentPageReport]="true" [rows]="5">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>{{'user name' | translator}}</th>
            <th>{{'Email' | translator}}</th>
            <th>{{'Phone Number'}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user let-columns="columns">
          <tr>
            <td>{{user?.name?.first}} {{user?.name?.middle}} {{user?.name?.last}}</td>
            <td>{{user?.email}}</td>
            <td>{{user?.phone}}</td>
          </tr>
        </ng-template>
      </p-table>

    </ng-container>

  </div>
</div>
<ng-template #spinner>
  <div class="spinner-container">
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-template>